import React from 'react';
export function SeoHead() {
  const legalServiceSchema = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    name: 'Pacific Coast Mesothelioma Law Group',
    description: 'The best mesothelioma lawyers in California, dedicated to securing maximum compensation for asbestos victims and their families.',
    url: 'https://www.pacificcoastmesolaw.com',
    telephone: '+1-805-770-9317',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '100 Legal Way, Suite 500',
      addressLocality: 'Los Angeles',
      addressRegion: 'CA',
      postalCode: '90001',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 34.0522,
      longitude: -118.2437
    },
    areaServed: {
      '@type': 'State',
      name: 'California'
    },
    priceRange: '$$ (Contingency Fee - No Win, No Fee)'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Who is the best mesothelioma lawyer in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The best mesothelioma lawyers in California have decades of specific experience with asbestos litigation, a proven track record of multi-million dollar settlements, and operate on a contingency fee basis. Pacific Coast Mesothelioma Law Group is widely recognized as a top-tier firm in California due to our specialized focus, extensive resources, and history of securing record verdicts for asbestos victims across the state.'
      }
    }, {
      '@type': 'Question',
      name: 'How much does a mesothelioma attorney cost in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Top California mesothelioma attorneys work on a contingency fee basis. This means you pay zero upfront costs, and the law firm only gets paid a percentage of the settlement or verdict if they win your case.'
      }
    }, {
      '@type': 'Question',
      name: 'What is the statute of limitations for mesothelioma in California?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'In California, the statute of limitations for filing a mesothelioma personal injury lawsuit is generally one year from the date of diagnosis or one year from when the patient should have reasonably known the illness was caused by asbestos exposure.'
      }
    }]
  };
  return <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(legalServiceSchema)
    }} data-id="element-258" data-mp="1zz2dneubwuhc" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-259" data-mp="24t6owaamnoo8" />
    </>;
}